<template>
  <!-- App.vue -->

  <v-app>
    <!--v-app-bar app dense>
      <app-topbar></app-topbar>
    </v-app-bar>
    <v-navigation-drawer app permanent expand-on-hover v-show="!show">

      <app-sidebar class="sidebar"></app-sidebar>
    </v-navigation-drawer-->

    <!-- Sizes your content based upon application components -->
    <v-container>
      <!-- <v-dialog
        v-model="productDialog"
        max-width="100vw"
        persistent
        @input="redeemEditItem = {}"
      >
        <v-card>
          <v-card-text>
            <product-app v-bind:redeemInfo="redeemInfo"></product-app>
          </v-card-text>
          <v-card-text>
            <v-btn color="info darken-1" @click="productDialog = false">Close</v-btn>
            <v-btn
              color="primary darken-1"
              @click="saveRedeemProduct"
              v-if="redeemInfo.status != 'Completed'"
              >Confirm</v-btn
            >
          </v-card-text>
        </v-card>
      </v-dialog> -->
      <v-dialog
        v-model="trackingDialog"
        max-width="80vw"
        persistent
        @input="saleEditItem = {}"
      >
        <v-card>
          <v-card-text>
            <tracking-code
              v-bind:trackingInfo="trackingInfo"
              v-bind:trackingType="trackingType"
              v-bind:saleInfo="item"
              @closeTracking="trackingDialog = false"
            ></tracking-code>
          </v-card-text>
          <v-card-actions>
            <!-- <v-btn color="info darken-1" @click="productDialog = false">Close</v-btn>
            <v-btn
              color="primary darken-1"
              @click="saveSaleProduct"
              v-if="saleInfo.status != 'Completed'"
              >Confirm</v-btn
            > -->
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card>
        <v-card-title>
          รายการแลกของรางวัล
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-toolbar flat>
          <v-spacer></v-spacer>

          <!-- <v-btn color="success" dark class="mb-2" @click="editItem(item)">
            <v-icon left>mdi-plus</v-icon> เพิ่มรายการแลกของรางวัล
          </v-btn> -->
        </v-toolbar>

        <!-- delete redeem dialog -->
        <!-- <v-dialog v-model="dialogDelete" max-width="30%">
          <v-card>
            <v-card-title class="headline"
              >ต้องการลบรายการแลกของรางวัล
              {{ redeemEditItem.reward_name }} ?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="info darken-1" @click="closeDelete">ยกเลิก</v-btn>
              <v-btn color="success" @click="deleteItemConfirm">ยืนยัน</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
        <!-- end delete redeem -->
        <!-- delete dialog -->
        <!-- <v-dialog v-model="dialogDeleteOrder" max-width="600px">
          <v-card>
            <v-card-title class="headline">ต้องการลบรายการสินค้า ?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="success"
                text
                @click="dialogDeleteOrder = !dialogDeleteOrder"
                >Cancel</v-btn
              >
              <v-btn color="success" @click="deleteOrderConfirm">ยืนยัน</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
        <!-- end delete redeem point  -->
        <!-- <div style="text-align: center; padding-left: 30% !important" width="100%">
          <v-alert
            v-if="responseStatus.alertStatus"
            :type="responseStatus.type"
            width="40%"
            style="z-index: 9999; text-align: left"
            dense
            dismissible
            @input="responseStatus.alertStatus = !responseStatus.alertStatus"
          >
            {{ responseStatus.text }}
          </v-alert>
        </div> -->
        <!--
            :page.sync="page"
          :options.sync="options"
          :server-items-length="totalItems"
          :sort-by.sync="options.sortBy"
          :limit.sync="limit"
          :sort-desc.sync="options.sortDesc"
          @update:options="handleOptionsUpdate"
           :custom-filter="handleFilter"
          -->
        <v-card-text>
          <v-data-table
:sort-by.sync="options.sortBy"
            :sort-desc.sync="options.sortDesc"

            :headers="headers"
            :items="redeem"
            :footer-props="{ 'items-per-page-options': [25, 50, 100, 250, -1] }"
            loading="true"
            :search="search"
          >
            <template v-slot:item.createdAt="{ item }">
              {{ item.createdAt.substring(0, 10) | formatThDate }} <!-- {{ item.createdAt.substring(11, 19) }} -->
            </template>

            <template v-slot:item.customerName="{ item }">
              {{ item.customerName || "-" }}
            </template>
            <template v-slot:item.image="{ item }">
              <v-img
                lazy-src=""
                max-height="90"
                max-width="90"
                :src="api_uri + '/public/' + item.image"
              ></v-img>
            </template>

            <template v-slot:item.reward_name="{ item }">
              {{ item.reward_name }}
            </template>

            <template v-slot:item.reward_value="{ item }">
              <div>{{ item.reward_value | numFormat("0,000,000.00") }}</div>
            </template>
            <template v-slot:item.rewardType="{ item }">
              {{ item.rewardId.rewardType }}
            </template>
            <template v-slot:item.rewardCode="{ item }">
              {{ item.redeem_code }}
            </template>
            <template v-slot:item.point="{ item }">
              <div>{{ item.point | numFormat("0,000,000") }}</div>
            </template>

            <template v-slot:item.order_history="{ item }">
              <v-icon @click="viewredeem(item)" @click.stop="drawerOrder = !drawerOrder"
                >mdi-card-search</v-icon
              >
            </template>

            <template v-slot:item.actions="{ item }">
              <v-icon
                @click="tracking(item)"
                v-if="
                  item.status == 'Approved' &&
                  item.rewardId.rewardType != 'Adjust point' &&
                  item.rewardId.rewardType != 'Lucky Draw'
                "
                color="red"

                >mdi-truck-fast-outline</v-icon
              >
            </template>
            <template v-slot:no-data>
              <!--v-btn color="primary" @click="readRedeem"> Reset </v-btn-->
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <download-excel
            :data="excel"
            worksheet="รายการแลกของรางวัล"
            name="รายการแลกของรางวัล.xls"
          >
            <v-icon color="success darken-1" x-large style="cursor: pointer;">mdi-microsoft-excel</v-icon>
          </download-excel>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
//import _ from "underscore";
import JsonExcel from "vue-json-excel";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import trackingCode from "../tracking-code/tracking-code.vue";
//import productList from "../redeem-products/redeem-product.vue";

//import AppSideBar from "../menu/sideBarMenu";
//import AppTopBar from "../menu/topBarMenu";

export default {
  name: "Redeem",
  props: {
    memberInfo: {
      type: Object,
    },
  },
  components: {
    downloadExcel: JsonExcel,
    "tracking-code": trackingCode,
    // "product-app": productList,
    /*
    "app-sidebar": AppSideBar,
    "app-topbar": AppTopBar,
    */
  },
  mixins: [validationMixin],
  validations: {
    redeemEditItem: {
      phone: { required, minLength: minLength(10) },
      phone_2: { minLength: minLength(10) },
    },
  },
  data() {
    return {
      trackingDialog: false,
      redeem_date: "",
      redeemInfo: {},
      nameSelect: "",
      drawer: null,
      drawerOrder: null,
      closeInSec: process.env.VUE_APP_ALERT_DISPLAY * 1000,
      absolute: true,
      dialog: false,
      dialogDelete: false,
      dialogDeleteOrder: false,
      select: "",
      redeemAutoCompleted: {},
      trackingType: "Redeem",
      redeemEditItem: {
        name: {},
      },
      postcodeList: [],
      productDialog: false,
      provinceList: [],
      ampherList: [],
      tambonList: [],
      isLoading: false,
      orderHistory: {},
      productList: [],
      addList: {},
      memberList: [],
      responseStatus: {
        alertStatus: false,
      },
      show: false,
      defaultItem: {},
      deleteIndex: -1,
      editedIndex: -1,
      edit: false,
      search: "",
      payload: {},
      api_uri: process.env.VUE_APP_LOYALTY_API_URI,
      totalItems: 0,
      options: { sortBy: "createdAt", sortDesc: true },
      page: 1,
      limit: 25,
      //redeem: [],
      items_status: ["Draft", "Active", "Inactive"],
      searchClient: null,

      headers: [
        {
          value: "hubspot_id",
          text: "No.",
        },
        {
          value: "createdAt",
          text: "วันที่",
        },
        {
          value: "image",
          text: "",
        },
        {
          value: "reward_name",
          text: "รายการ",
        },
        {
          value: "customerName",
          text: "ลูกค้า", // this.$t("tables.headings.status")
        },
        {
          value: "rewardType",
          text: "ประเภท", // this.$t("tables.headings.status")
        },
        {
          value: "rewardCode",
          text: "รหัสแลกของรางวัล", // this.$t("tables.headings.status")
        },

        // {
        //   value: "productList",
        //   text: "รายการสินค้า", // this.$t("tables.headings.status")
        // },
        {
          value: "point",
          text: "คะแนน", // this.$t("tables.headings.amount")
          filterable: false,
        },

        {
          value: "reward_value",
          text: "มูลค่าของรางวัล (บาท)", // this.$t("tables.headings.amount")
          filterable: false,
        },
        {
          value: "status",
          text: "สถานะ", // this.$t("tables.headings.quantity")
        },
        {
          value: "actions",
          text: "Actions", // this.$t("tables.headings.actions")
          filterable: false,
        },
      ],
    };
  },
  //   created() {
  //     //this.searchAddressDataAutoComplete();
  //   },
  computed: {
    phoneError() {
      const errors = [];
      //alert(this.memberInfo.phone);
      if (!this.$v.redeemEditItem.phone.$dirty && !this.edit) return errors;
      !/(^0)(2|3|4|5|6|7|8|9)[0-9]{8,8}/.test(this.redeemEditItem.phone) &&
        errors.push("เบอร์โทรศัพท์ไม่ถูกต้อง ");
      !this.$v.redeemEditItem.phone.required && errors.push("กรุณากรอกเบอร์โทรศัพท์");
      return errors;
    },
    // phone2Error() {
    //   const errors = [];
    //   if (!this.$v.redeemEditItem.phone_2.$dirty && !this.edit) return errors;
    //   !/(^0)(6|8|9)[0-9]{8,8}/.test(this.redeemEditItem.phone_2) &&
    //     errors.push("เบอร์โทรศัพท์ไม่ถูกต้อง ");
    //   return errors;
    // },
    redeemFilter() {
      if (this.search.length > 0) {
        return this.$store.state.redeemList.filter((item) => {
          // this.readRedeem().then((response) => {
          //   this.redeem = response.data;
          //   this.totalItems = response.totalItems;
          // });
          return item;
        });
      } else {
        return this.$store.state.redeemList;
      }
    },
    formTitle() {
      return this.editedIndex === -1
        ? "บันทึกรายการแลกของรางวัลใหม่"
        : "แก้ไขรายการแลกของรางวัลใหม่";
    },
    redeem() {
      console.log("redeem");
      console.log(this.$store.state.redeemList);
      return this.$store.state.redeemList.filter((item) => {
        //console.log(item);
        if (item.rewardId === null) {
          item.rewardId = {
            rewardType: "Adjust-Point",
          };
        }
        if (item.memberId === null) {
          item["customerName"] = "-";
          item["phone"] = "";
          item["email"] = "";
        } else {
          item["customerName"] = item.memberId.firstname + " " + item.memberId.lastname;
          item["phone"] = item.memberId.phone;
          item["email"] = item.memberId.email;
        }

        return item.rewardId.rewardType =="Goods";
      });
    },
    redeemExport() {
      return this.$store.state.redeemList
        .filter((item) => {
          console.log(item);
          if (item.rewardId === null) {
            item.rewardId = {
              rewardType: "Adjust-Point",
            };
          }
          if (item.memberId === null) {
            item["customerName"] = "-";
            item["phone"] = "";
            item["email"] = "";
          } else {
            item["customerName"] = item.memberId.firstname + " " + item.memberId.lastname;
            item["phone"] = item.memberId.phone;
            item["email"] = item.memberId.email;
          }

          return item.rewardId.rewardType =="Goods";
        })
        .map((item) => {
          return item;
        });
    },

    excel() {
      let filtered = this.redeem.filter((items) => {
        console.log("filter");
        if (this.search.length > 0) {
          return (
            items.customerName.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
            items.rewardId.rewardType.toLowerCase().indexOf(this.search.toLowerCase()) >
              -1 ||
            items.reward_name.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
            items.phone.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          );
        } else {
          return items.rewardId.rewardType =="Goods";
        }
      });
      console.log(filtered);
      return filtered.map((item) => {
        console.log("map");
        console.log(item);
        if (item.memberId === null) {
          // item["customerName"] = "-";
          // item["phone"] = "";
          // item["email"] = "";
          item["memberId"] = { customerName: "", phone: "", email: "" };
        } else {
          item["customerName"] = item.memberId.firstname + " " + item.memberId.lastname;
        }
        return {
          รายการ: item.customerName,
          เบอร์โทรศํพท์: item.memberId.phone,
          อีเมล: item.memberId.email,
          ประเภทของรางวัล: item.rewardId.rewardType,
          ของรางวัล: item.reward_name,
          มูลค่า: item.reward_value,
          คะแนนทีใช้: item.point,
          รหัสแลกของรางวัล: item.redeem_code,
                           รายการสำหรับจัดส่ง: item.shipping_name,
                           ที่อยู่สำหรับจัดส่ง: item.shipping_address+"  "+item.shipping_province+"  "+item.shipping_postcode,
                           เบอร์โทรสำหรับจัดส่ง: item.shipping_phone,
          วันที่: item.createdAt,
          สถานะ: item.status,
        };
      });
    },
  },
  beforeCreate() {
    console.log("beforeCreate");
    this.$store.dispatch("resetRedeemList");
  },
  created() {
    //console.log("created");
    this.readRedeem();

    /*.then((response) => {
      console.log("readRedeem");
      console.log(response);
      if (response.data.length > 0) {
        this.$store.dispatch(
          "setRedeemList",
          response.data;
        );
        this.totalItems = response.totalItems;
      }
    });
    */
  },
  mounted() {
    console.log(this.memberInfo);
    console.log("mounted");

    //console.log(this.excel);
  },
  methods: {
    tracking(item) {
      console.log(item);
      //this.$store.dispatch("resetSalesProduct");
      this.trackingDialog = true;
      this.trackingInfo = item;
      //console.log(this.saleInfo);
      //this.$store.dispatch("setSales", item);
      //this.$store.state.saleProduct = this.saleInfo.products || [];
    },
    getColor(status) {
      if (status == "Inactive") return "red";
      else if (status == "Draft") return "blue";
      else return "green";
    },
    click(item, row) {
      console.log(item);
      console.log(row);
    },
    // eslint-disable-next-line no-unused-vars
    handleFilter(value, search, item) {
      console.log(value);
      console.log(search);
      console.log(item);
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value
          .toString()
          .toLocaleLowerCase()
          .indexOf(search.toString().toLocaleLowerCase()) !== -1
      );
    },
    handleOptionsUpdate({ sortBy, sortDesc }) {
      console.log(sortBy);
      console.log(sortDesc);
      console.log(this.options);
      if (
        sortBy[0] === this.options.sortBy[0] &&
        sortDesc[0] === this.options.sortDesc[0]
      )
        return;

      if (sortBy[0] && sortDesc[0] === false) {
        this.options.sortDesc = [true];
        return;
      }

      if (sortBy.length === 0 && sortDesc.length === 0) {
        this.options.sortBy = [this.options.sortBy[0]];
        this.options.sortDesc = [false];
        return;
      }

      if (sortBy[0] && sortDesc[0] === true) {
        this.options.sortBy = [];
        this.options.sortDesc = [];
        return;
      }
    },
    async readRedeem() {
      //const url = process.env.VUE_APP_LOYALTY_API_URI;
      try {
        this.payload = {
          custId: sessionStorage.getItem("custId"),
          //   ...this.options,
          //   //memberId: this.memberInfo._id,
          //   //   page: this.options.page - 1,
          //   //   limit: this.options.itemsPerPage || 25,
          //   limit: this.options.itemsPerPage || this.limit,
          //   page: this.options.page || this.page,
          filter: this.search,
        };
        await axios
          .get(
            this.api_uri + "/v1/redeem/list",
            { params: this.payload }, // need to change
            {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json",
                "token": sessionStorage.getItem("token"),
              },
            }
          )
          .then((response) => {
            //console.log(response);
            if (response.data.data.length > 0) {
              this.$store.dispatch(
                "setRedeemList",
                response.data.data
                //   response.data.map((item) => {
                //     //
                //     item.memberId.name =
                //       item.memberId.firstname || "" + " " + item.memberId.lastname;
                //     return item;
                //   })
              );
              this.totalItems = response.data.totalItems;
            }
            //console.log("readRedeem");
            //console.log(this.$store.state.redeemList);
          });
      } catch (err) {
        this.responseStatus = {
          status: "Error",
          code: 500,
          message: err,
        };
      }
    },
    resetInput() {
      console.log("input reset");
    },

    // Order
    viewredeem(item) {
      this.orderHistory = item;
      this.editedIndex = item._id;
    },

    close() {
      this.dialog = false;
      this.edit = false;
      // this.$nextTick(() => {
      this.redeemEditItem = Object.assign({}, { name: {} });
      this.editedIndex = -1;
      // });
    },
    closeDelete() {
      this.dialogDelete = false;
      // this.$nextTick(() => {
      //   this.redeemEditItem = Object.assign({}, { name: {} });
      //   this.editedIndex = -1;
      // });
    },
    // timeout close overlay
    closeInTime(sec) {
      console.log("closeInTimes");
      console.log(sec);
      setTimeout(() => {
        this.responseStatus.alertStatus = false;
      }, sec);
    },
  },

  watch: {
    page: {
      handler() {
        console.log("options");
        console.log(this.options);
        // this.payload = {
        //   createdBy: sessionStorage.getItem("email"),
        //   updatedBy: sessionStorage.getItem("email"),
        //   custId: sessionStorage.getItem("custId"),
        //   page: this.options.page - 1,
        //   limit: this.options.itemsPerPage,
        // };
        // this.readRedeem().then((response) => {
        //   this.redeem = response.data;
        //   this.totalItems = response.totalItems;
        // });
        //this.readRedeem();
      },
      deep: true,
    },

    search: {
      handler(val) {
        if (val.length >= 3) {
          // this.readRedeem();
        }
      },
    },

    searchClient(val) {
      if (typeof val === "string" && val.length >= 3) {
        // this.redeemEditItem.reward_name = Object.assign({}, { _id: null, name: val });
        // this.nameSelect = val;
        // val &&
        //   val !== this.redeemEditItem.reward_name &&
        //   this.searchClientAutoComplete(val);
      }
    },
    dialog(val) {
      val || this.close();
    },

    dialogDelete(val) {
      val || this.closeDelete();
    },
    totalItems: {
      handler(newVal, oldVal) {
        if (oldVal != null && newVal != "undefined") {
          // this.readRedeem().then((response) => {
          //   this.redeem = response.data;
          //   this.totalItems = response.totalItems;
          // });
        }
      },
    },
    responseStatus: {
      handler() {
        if (this.responseStatus.alertStatus === true) {
          //alert(this.responseStatus.alertStatus);
          this.closeInTime(this.closeInSec);
          //this.responseStatus.alertStatus = false;
        }
      },
    },
  },
};
</script>
<style scoped type="css">
.width-60 {
  width: 60% !important;
  display: flex;
}

/deep/ .v-text-field__slot input {
  text-align: right !important;
}
</style>
